import { CLASS_NAMES } from "../../utils/constants";
import Wall from "./Wall";

class Block extends Wall {}

Block.className = CLASS_NAMES.BLOCK
export default Block;
